<template>
  <div class="container en025">

    <notice-box class="-success _mb-sm-40 _mb-md-60 _mt-sm-15 _mt-md-60">
      <notice-header>
        <h1 class="heading">会員さま専用サイトへログインのうえご利用ください。</h1>
      </notice-header>
    </notice-box>

    <btngroup-single class="_mb-sm-40">
      <btn-main class="-main" routerName="ce001">
        会員さま専用サイトトップへ
      </btn-main>
    </btngroup-single>

    <btngroup-single class="-margin-lg">
      <btn-main class="-normal -lg" routerName="sv001">
        au PAY スマートローントップへ
      </btn-main>
    </btngroup-single>

  </div><!-- container -->
</template>

<script>
import { removeUserSessionCookie } from '../utils/Auth'
import NoticeBox from '../components/box/NoticeBox'
import NoticeBody from '../components/box/NoticeBody'
import NoticeHeader from '../components/box/NoticeHeader'
import BtnMain from '../components/button/BtnMain'
import BtngroupSingle from '../components/button/BtngroupSingle'

export default {
  name: 'En-025',
  metaInfo: {
    title: 'au PAY スマートローン',
    titleTemplate: null,
    meta: [
      {name: 'description', content: 'au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。'},
      {name: 'keywords', content: 'au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,入会'}
    ]
  },
  components: {
    BtngroupSingle,
    BtnMain,
    NoticeHeader,
    NoticeBody,
    NoticeBox
  },
  mounted () {
    removeUserSessionCookie()
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/stylesheets/styles";

</style>



// WEBPACK FOOTER //
// src/pages/En025.vue